// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LULjy","title":"styles_title__22jVL"};